import { useEffect, useState } from 'react';
import { useAnalyticsTracking } from '@/hooks/useAnalyticsTracking';
import { useErrorTracking } from '@/hooks/useErrorTracking';
import { usePerformanceTracking } from '@/hooks/usePerformanceTracking';
import { usePresenceTracking } from '@/hooks/usePresenceTracking';
import { useAdvancedTracking } from '@/hooks/useAdvancedTracking';
import { useCookieTracking } from '@/hooks/useCookieTracking';
import { CookieConsentBanner } from '@/components/CookieConsentBanner';

// Analytics Provider v3 - Deferred tracking for performance

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

function DeferredTrackingInner() {
  useAnalyticsTracking();
  useErrorTracking();
  usePerformanceTracking();
  usePresenceTracking();
  useAdvancedTracking();
  useCookieTracking();
  return null;
}

export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  const [trackingReady, setTrackingReady] = useState(false);

  useEffect(() => {
    // Defer analytics 3s so FCP/LCP are not blocked
    const timer = setTimeout(() => setTrackingReady(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  // Mark returning visitors
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const hasVisited = localStorage.getItem('xpand_returning_visitor');
      if (!hasVisited) {
        setTimeout(() => {
          localStorage.setItem('xpand_returning_visitor', 'true');
        }, 5000);
      }
    }
  }, []);

  return (
    <>
      {children}
      {trackingReady && <DeferredTrackingInner />}
      <CookieConsentBanner />
    </>
  );
}